import { $color_grey_2, $color_grey_6, $color_blue_5 } from '../pebbleGlobalToken/color.js';
import { $spacing_l1 } from '../pebbleGlobalToken/spacing.js';

/**
 * 警示信息-颜色-信息-背景
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-2
 */
var $alert_color_info_bg = $color_grey_2;

/**
 * 警示信息-颜色-信息-边框
 * @description enDesc: -
 * @description type: Color
 * @description value: $color-grey-6
 */
var $alert_color_info_border = $color_grey_6;

/**
 * 警示信息-高度-边框
 * @description enDesc: -
 * @description type:
 * @description value: 30
 */
var $alert_info_height = 30;

/**
 * 警示信息-info-图标-颜色
 * @description enDesc: -
 * @description type:
 * @description value: color_blue_5
 */
var $alert_info_icon_color = $color_blue_5;

/**
 * 警示信息-带描述信息的alert-minHeight
 * @description enDesc: -
 * @description type:
 * @description value: 64
 */
var $alert_desc_min_height = 64;

/**
 * 警示信息-顶部通告形式-minHeight
 * @description enDesc: -
 * @description type:
 * @description value: 40
 */
var $alert_banner_min_height = $spacing_l1;

export { $alert_banner_min_height, $alert_color_info_bg, $alert_color_info_border, $alert_desc_min_height, $alert_info_height, $alert_info_icon_color };
